import { createReducer } from './../../utilities/miscellaneous'

export const INITIAL_STATE = {
  initialized: false,
}
export const INITIALIZED = 'truvid/INITIALIZED'

// initialized :: () -> Action
export const initialized = () => ({ type: INITIALIZED })

export default createReducer(INITIAL_STATE, {
  [INITIALIZED]: state => ({
    ...state,
    initialized: true,
  }),
})
